import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { TranslateModule } from '@ngx-translate/core';
import { CreateTieComponent } from './create-tie.component';
import { AddTemplateModule } from '../../_shared/components/add-template/add-template.module';
import { SelectTeamComponentModule } from '../../my-teams/select-team/select-team.module';
import { CreateMatchModule } from '../../matches/create-match/create-match.module';
import { SharedModule } from '../../_shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        TranslateModule.forChild(),
        AddTemplateModule,
        SelectTeamComponentModule,
        CreateMatchModule,
        SharedModule
    ],
    declarations: [
        CreateTieComponent,
    ]
})
export class CreateTieModule { }
